export class NameDisplayPreference {

    firstName: string;
    middleName: string;
    lastName: string;
    customFirstName: string;
    customMiddleName: string;
    customLastName: string;
    keepAsIs: boolean;


    constructor() {
        this.firstName = '';
        this.middleName = '';
        this.lastName = '';
        this.customFirstName = '';
        this.customMiddleName = '';
        this.customLastName = '';
        this.keepAsIs = false;
    }
}